import { styled, mq } from 'mymoria-ui';
import { Card } from 'mymoria-ui/components';

export default styled(Card)(
  mq({
    margin: 'auto',
    marginBottom: ['60px', '80px'],
  }),
);
